module.exports = __webpack_public_path__ + "img/logo-full_dark.bc66cccf.svg";